import { getItemsPrice } from "../index.js";

// get plan and save items using main order items
// if shortcut is selected in main order, need to split it to
// the shortcut's contents, not the shortcut itself
export function getPlanAndSaveItems(mainOrderItems, testList, panelList) {
  let planAndSaveItems = [];
  mainOrderItems.forEach(item => {
    if (item.category === "shortcut") {
      let { customPanelIdList, discountPanelIdList, testIdList, xChooseYIdList } = item;
      let panelIds = customPanelIdList.concat(discountPanelIdList)
        .concat(xChooseYIdList.map(xChooseY => xChooseY.bundleId));
      let panels = panelList.filter(panel => panelIds.includes(panel.bundleId));
      let tests = testList.filter(test => testIdList.includes(test.id));
      planAndSaveItems = planAndSaveItems.concat(panels).concat(tests);
    }
    else {
      planAndSaveItems.push(item);
    }
  });
  return planAndSaveItems;
}

// get plan&save discount eligible items
// discount will be eligible on following items:
// vw tests, xChooseY, discount panels formed by vw only, and whole dbs menu
// all other tests and bundles remain original prices
// note that custom panels and shortcuts are not eligible, even in dbs menu
export function getPlanAndSaveEligibleItems(isDbs, planAndSaveItems, testList) {
  let discountEligibleItems = [];
  if (isDbs) { // dbs menu
    // note that dbs discount panel formed by vw only
    discountEligibleItems = planAndSaveItems
      .filter(item => ["vw", "discountPanel", "xChooseY"].includes(item.category));
  }
  else { // normal menu
    // find discount panels formed by vw only
    let eligibleDiscountPanels = planAndSaveItems
      .filter(item => item.category === "discountPanel")
      .filter(panel => {
        let testsInPanel = testList
          .filter(test => panel.testIdsInPanel.includes(test.id));
        return testsInPanel.some(test => test.category === "vw");
      });
    // eligible discount items = vw tests + vw formed discount panels + xChooseY
    discountEligibleItems = planAndSaveItems
      .filter(item => ["xChooseY", "vw"].includes(item.category)).concat(eligibleDiscountPanels);
  }
  return discountEligibleItems;
}

// get original & discount plan&save price for planned orders
export function getPlanAndSavePrice(planAndSaveItems, discountEligibleItems, discountPercent, vwTestList) {
  // find current plan & save items total price (before discount)
  let originalPrice = getItemsPrice(planAndSaveItems, vwTestList);
  // find discount eligible price
  let discountEligiblePrice = getItemsPrice(discountEligibleItems, vwTestList);
  // get final price after apply discount on eligible plan&save items
  let discountPrice = (originalPrice - discountEligiblePrice) 
    + discountEligiblePrice * ( 1 - discountPercent * 0.01);
  return { originalPrice, discountPrice };
}


// convert 1, 2, 3, 4 etc. to string like 1st, 2nd, 3rd, 4th etc. 
export function convertNumberToSequence(num) {
  const lastDigit = num % 10;
  const specialCases = [11, 12, 13];

  if (specialCases.includes(num % 100)) {
    return num + 'th';
  }

  switch (lastDigit) {
    case 1:
      return num + 'st';
    case 2:
      return num + 'nd';
    case 3:
      return num + 'rd';
    default:
      return num + 'th';
  }
}

